/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // add an event listener which finds any review-items on the page and then opens their sibling modal, it must propogate up to the document level to work on dynamically added elements
  document.addEventListener("click", function(event) {
    const parentElement = event.target.closest(".testimonial__item");

    if (parentElement) {
        const modalId = parentElement.dataset.modalId;
        const modal = document.getElementById(modalId);
        if (modal) {
            modal.classList.add("is-active");
        }
    }
  });

  const closeButtons = document.querySelectorAll("[data-modal-close]");

  closeButtons.forEach(function(button) {
    button.addEventListener("click", function(event) {
        const modal = event.target.closest(".modal-wrapper");
        if (modal) {
            modal.classList.remove("is-active");
        }
    });
  });

  Dropzone.autoDiscover = false; // Ensure Dropzone does not auto-init

  function initialize(element, id, inputId, fileNameInputId) {
      new Dropzone(id, {
        url: "/",
        autoProcessQueue: false, // Prevent auto-upload
        maxFilesize: 10, // Shopify limit (20MB)
        acceptedFiles: "image/jpeg,image/png,image/gif,application/pdf",
        maxFiles: 1, // Limit to 1 file
        dictDefaultMessage: '<span class="choose-file">Choose File</span><span class="message">or drop a file to upload</span>',
        previewTemplate: `
            <div class="dz-preview">
                <div class="dz-image">
                    <img data-dz-thumbnail />
                </div>
                <div class="dz-filename"><span data-dz-name></span></div>
                <div class="dz-remove" data-dz-remove>
                  <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"> <path d="M11.586 13l-2.293 2.293a1 1 0 0 0 1.414 1.414L13 14.414l2.293 2.293a1 1 0 0 0 1.414-1.414L14.414 13l2.293-2.293a1 1 0 0 0-1.414-1.414L13 11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L11.586 13z" fill="currentColor" fill-rule="nonzero"></path> </svg>
                </div>
            </div>
        `,
        init: function() {
          let fileInput = document.getElementById(inputId);
          let fileNameInput = document.getElementById(fileNameInputId);
          let dropzoneWrapper = element.closest('.dropzone-wrapper') || element.closest('#qb-dropzone-wrapper') || element.closest('#qb-back-engraving-dropzone-wrapper');
          
          this.on('addedfile', function (file) {
              if (this.files.length > 1) {
                  this.removeFile(this.files[0]);
              }

              // Convert file to DataTransfer object and assign to input
              let dataTransfer = new DataTransfer();
              dataTransfer.items.add(file);
              fileInput.files = dataTransfer.files;
              
              // Ensure the file input has the correct name attribute
              if (inputId === 'qb-back-engraving-file-input') {
                fileInput.setAttribute('name', 'properties[Back Engraving File Upload]');
                fileInput.setAttribute('data-property-name', 'Back Engraving File Upload');
              }
              
              if (fileNameInput) {
                fileNameInput.value = file.upload ? file.upload.filename : file.name;
              }
              
              // Remove error state if present
              if (dropzoneWrapper) {
                dropzoneWrapper.classList.remove('error');
                const errorMessage = dropzoneWrapper.querySelector('.error-message');
                if (errorMessage) {
                  errorMessage.style.display = 'none';
                }
              }
          });

          this.on("removedfile", function(file) {
            if (fileInput) {
              fileInput.value = "";
              // Create a new empty FileList
              const dataTransfer = new DataTransfer();
              fileInput.files = dataTransfer.files;
              
              // Disable back engraving input when file is removed
              if (inputId === 'qb-back-engraving-file-input') {
                fileInput.setAttribute('disabled', 'true');
              }
            }
            if (fileNameInput) {
              fileNameInput.value = "";
            }
            
            // Add error state if required
            if (dropzoneWrapper && fileInput.hasAttribute('required')) {
              dropzoneWrapper.classList.add('error');
              const errorMessage = dropzoneWrapper.querySelector('.error-message');
              if (errorMessage) {
                errorMessage.style.display = 'block';
              }
            }
          });
        }
    });

    const form = element.closest("form");

    let variantSelect = form.querySelector('input[name="options[Engraving Options]"]');
    
    if (!variantSelect) {
      variantSelect = form.querySelector('input[name="options[Type of Engraving]"]');
    }
    if (!variantSelect) {
      variantSelect = form.querySelector('input[name="options[Types of Engraving]"]');
    }
    if (!variantSelect) {
      variantSelect = form.querySelector('input[name="options[Style]"]');
    }

    // Also look for Back Engraving option
    let backEngravingSelect = form.querySelector('input[name="options[Back Engraving]"]:checked');
    const personalisationTextarea = document.getElementById("qb-personalisation-textarea");
    const dropzoneWrapper = document.getElementById("qb-dropzone-wrapper");
    const backEngravingTextarea = document.getElementById("qb-back-engraving-textarea");
    const backEngravingDropzoneWrapper = document.getElementById("qb-back-engraving-dropzone-wrapper");

    variantSelect.addEventListener("change", handleVariantChange);

    // Add listeners to back engraving options to update our UI
    const backEngravingOptions = form.querySelectorAll('input[name="options[Back Engraving]"]');
    backEngravingOptions.forEach(function(option) {
      // Check if it has the required data attributes
      const hasSelector = option.hasAttribute('data-single-option-selector');
      const hasIndex = option.hasAttribute('data-index');
      
      // Listen to changes to update our engraving fields
      option.addEventListener('change', function(e) {
        setTimeout(handleVariantChange, 150);
      }, false);
    });

    // Function to apply visibility logic based on variant selection
    function handleVariantChange() {
      const selectedVariantText = variantSelect.value;
      const backEngravingChecked = form.querySelector('input[name="options[Back Engraving]"]:checked');
      const backEngravingValue = backEngravingChecked ? backEngravingChecked.value : '';

      // Determine what types of engraving are needed
      const needsTextEngraving = selectedVariantText.includes("Classic Engraving") || selectedVariantText.includes("Standard Engraving");
      const needsFrontFileUpload = selectedVariantText.includes("Handwriting") || selectedVariantText.includes("Fingerprint") || selectedVariantText.includes("Paw") || selectedVariantText.includes("Ink Pad") || selectedVariantText.includes("Inkpad") || selectedVariantText.includes("Back Engraving") || selectedVariantText.includes("Image Upload") || selectedVariantText.includes("Foot print");
      const needsBackEngravingUpload = backEngravingValue === "Yes";

      // Handle text engraving (show if needed)
      if (personalisationTextarea) {
        if (needsTextEngraving) {
          personalisationTextarea.style.display = "block";
          const textarea = personalisationTextarea.querySelector('textarea');
          if (textarea) {
            textarea.setAttribute("required", true);
            textarea.removeAttribute("disabled"); // Re-enable
            // Restore name attribute for form submission
            if (!textarea.getAttribute('name')) {
              textarea.setAttribute('name', 'properties[Classic Font]');
            }
            // Don't clear the value when showing - preserve user's text
          }
          // Remove error state
          personalisationTextarea.classList.remove('error');
          const errorMessage = personalisationTextarea.querySelector('.error-message');
          if (errorMessage) {
            errorMessage.style.display = 'none';
          }
        } else {
          personalisationTextarea.style.display = "none";
          const textarea = personalisationTextarea.querySelector('textarea');
          if (textarea) {
            textarea.removeAttribute("required");
            textarea.setAttribute("disabled", "true"); // Disable instead of removing name
            textarea.value = ''; // Clear value only when hiding
          }
          // Remove error state
          personalisationTextarea.classList.remove('error');
          const errorMessage = personalisationTextarea.querySelector('.error-message');
          if (errorMessage) {
            errorMessage.style.display = 'none';
          }
        }
      }

      // Handle front file upload (show if needed)
      if (dropzoneWrapper) {
        if (needsFrontFileUpload) {
          dropzoneWrapper.style.display = "block";
          const fileInput = dropzoneWrapper.querySelector('input[type="file"]');
          const hiddenFileInput = dropzoneWrapper.querySelector('input[type="hidden"]');
          if (fileInput) {
            fileInput.setAttribute("required", true);
            fileInput.removeAttribute("disabled"); // Re-enable
            // Restore name attributes for form submission
            if (!fileInput.getAttribute('name')) {
              fileInput.setAttribute('name', 'properties[File Upload]');
            }
            // Don't clear file value when showing - preserve uploaded file
          }
          if (hiddenFileInput) {
            hiddenFileInput.removeAttribute("disabled");
            if (!hiddenFileInput.getAttribute('name')) {
              hiddenFileInput.setAttribute('name', 'properties[File]');
            }
          }
          // Don't clear Dropzone when showing - preserve uploaded files
        } else {
          dropzoneWrapper.style.display = "none";
          const fileInput = dropzoneWrapper.querySelector('input[type="file"]');
          const hiddenFileInput = dropzoneWrapper.querySelector('input[type="hidden"]');
          if (fileInput) {
            fileInput.removeAttribute("required");
            fileInput.setAttribute("disabled", "true"); // Disable instead of removing name
            fileInput.value = ""; // Clear only when hiding
          }
          if (hiddenFileInput) {
            hiddenFileInput.setAttribute("disabled", "true"); // Disable instead of removing name
            hiddenFileInput.value = ""; // Clear only when hiding
          }
          // Clear Dropzone only when hiding
          const dropzone = Dropzone.instances.find(dz => dz.element.id === 'qb-personalisation-dropzone');
          if (dropzone) {
            dropzone.removeAllFiles();
          }
        }
      }

      // Handle back engraving - show textarea for text-based, file upload for file-based
      const needsBackEngraving = needsBackEngravingUpload;
      const isTextBasedEngraving = needsTextEngraving;
      const isFileBasedEngraving = needsFrontFileUpload;
      const backEngravingNeedsText = needsBackEngraving && isTextBasedEngraving;
      const backEngravingNeedsFile = needsBackEngraving && isFileBasedEngraving;
      
      // Handle back engraving textarea (for text-based front engraving)
      if (backEngravingTextarea) {
        if (backEngravingNeedsText) {
          backEngravingTextarea.style.display = "block";
          const textarea = backEngravingTextarea.querySelector('textarea');
          if (textarea) {
            textarea.setAttribute("required", true);
            textarea.removeAttribute("disabled");
            textarea.setAttribute('name', 'properties[Back Engraving Text]');
            // Don't clear the value when showing - preserve user's text
          }
        } else {
          backEngravingTextarea.style.display = "none";
          const textarea = backEngravingTextarea.querySelector('textarea');
          if (textarea) {
            textarea.removeAttribute("required");
            textarea.setAttribute("disabled", "true");
            textarea.removeAttribute('name');
            textarea.value = ""; // Clear value only when hiding
          }
        }
      }
      
      // Handle back engraving file upload (for file-based front engraving)
      if (backEngravingDropzoneWrapper) {
        if (backEngravingNeedsFile) {
          backEngravingDropzoneWrapper.style.display = "block";
          const fileInput = backEngravingDropzoneWrapper.querySelector('input[type="file"]');
          const hiddenFileInput = backEngravingDropzoneWrapper.querySelector('input[type="hidden"]');
          if (fileInput) {
            fileInput.setAttribute("required", true);
            fileInput.removeAttribute("disabled");
            // Set name attributes for back engraving
            fileInput.setAttribute('name', 'properties[Back Engraving File Upload]');
            fileInput.setAttribute('data-property-name', 'Back Engraving File Upload');
            // Don't clear file value when showing - preserve uploaded file
          }
          if (hiddenFileInput) {
            hiddenFileInput.removeAttribute("disabled");
            hiddenFileInput.setAttribute('name', 'properties[Back Engraving File]');
          }
          // Don't clear Dropzone when showing - preserve uploaded files
        } else {
          backEngravingDropzoneWrapper.style.display = "none";
          const fileInput = backEngravingDropzoneWrapper.querySelector('input[type="file"]');
          const hiddenFileInput = backEngravingDropzoneWrapper.querySelector('input[type="hidden"]');
          if (fileInput) {
            fileInput.removeAttribute("required");
            fileInput.setAttribute("disabled", "true");
            fileInput.removeAttribute('name');
            fileInput.value = ""; // Clear only when hiding
          }
          if (hiddenFileInput) {
            hiddenFileInput.setAttribute("disabled", "true");
            hiddenFileInput.removeAttribute('name');
            hiddenFileInput.value = ""; // Clear only when hiding
          }
          // Clear Dropzone only when hiding
          const dropzone = Dropzone.instances.find(dz => dz.element.id === 'qb-back-engraving-dropzone');
          if (dropzone) {
            dropzone.removeAllFiles();
          }
        }
      }

      // Handle engraving shape dropdown - show only for fingerprint (if not disabled)
      const engravingShapeWrapper = document.getElementById("qb-engraving-shape-wrapper");
      if (engravingShapeWrapper) {
        const form = engravingShapeWrapper.closest('[data-product-form]');
        const disableEngravingShape = form && form.dataset.disableEngravingShape === 'true';
        const shapeInput = engravingShapeWrapper.querySelector('input[type="hidden"]');
        
        if (selectedVariantText.includes("Fingerprint") && !disableEngravingShape) {
          engravingShapeWrapper.style.display = "block";
          if (shapeInput) {
            shapeInput.setAttribute('name', 'properties[Engraving Shape]'); // Enable form submission
          }
        } else {
          engravingShapeWrapper.style.display = "none";
          if (shapeInput) {
            shapeInput.removeAttribute('name'); // Prevent form submission
            shapeInput.value = 'Normal'; // Reset to default
          }
        }
      }
    }

    // Listen for the theme's variant change event instead of direct variant select
    document.addEventListener('theme:variant:change', function(event) {
      setTimeout(function() {
        handleVariantChange();
      }, 50);
    });

    // Initialize visibility based on the initial variant selection - multiple attempts
    setTimeout(function() {
      handleVariantChange();
    }, 100);
    setTimeout(function() {
      handleVariantChange();
    }, 300);
    setTimeout(function() {
      handleVariantChange();
    }, 500);
    setTimeout(function() {
      handleVariantChange();
    }, 800);
    setTimeout(function() {
      handleVariantChange();
    }, 1200);
  }

  function waitForElement(selector, callback) {
      const observer = new MutationObserver(() => {
          const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element && !element.dataset.observed) {
              // Mark element as observed to prevent duplicate calls
              element.dataset.observed = "true";
              callback(element);
          }
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
  }

  // Example usage: Reinitialize Dropzone every time it appears
  waitForElement("#qb-personalisation-dropzone", (element) => {
      initialize(element, "#qb-personalisation-dropzone", "qb-personalisation-file-input", "qb-filename-input");
  });

  // Initialize back engraving dropzone
  waitForElement("#qb-back-engraving-dropzone", (element) => {
      initialize(element, "#qb-back-engraving-dropzone", "qb-back-engraving-file-input", "qb-back-engraving-filename-input");
  });

  waitForElement(".upcart-item-property", (element) => {
      const content = element.querySelectorAll('strong');
      
      content.forEach(el => {
        if (el.innerText.includes("_File")) {
            element.remove();
        }
        if (el.innerText.includes("_freebies")) {
            element.remove();
        }
      });
  });

  document.addEventListener('submit', function(e) {
    const productForm = e.target.closest('[data-product-form]');
    if (productForm && !e.target.closest('.quickbuy-form')) {
      
      // Check if the form has validation errors - if so, don't interfere
      const hasErrors = productForm.querySelector('.error') || 
                       productForm.querySelector('[data-cart-errors-container].is-visible');
      
      if (hasErrors) {
        return; // Let the validation handle it
      }
      
      e.preventDefault();
      const formData = new FormData(e.target);
      
      // Remove gift-related properties
      const propertiesToRemove = ['_is_gift', 'Add a Gift', 'Gift Selection'];
      for (let pair of formData.entries()) {
        const key = pair[0];
        if (key.includes('properties[')) {
          const propertyName = key.split('[')[1].split(']')[0];
          if (propertiesToRemove.some(prop => propertyName.includes(prop))) {
            formData.delete(key);
          }
        }
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Force UpCart refresh
        if (typeof upcartRefreshCart === 'function') {
          upcartRefreshCart();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

